// @flow

import React from 'react';
import SearchContainer from './search.container';

type ACFProps = {|
  results_page: string,
|};

export default ({
  results_page,
}: ACFProps) => <SearchContainer resultsPage={results_page} />;
